import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import '../../../assets/stylesheets/Union/UnionEditing.scss';
import Header from "../../Club/components/Header";
import { getClubUnion, getClubChipBalance, getGlobalAccountBalance, getAccountAvatars } from "../../../store/selectors";
import { changeUnionDetails } from '../../../store/actionCreators/union';
// import {} from "../../../../store/actionCreators/union";

const EditUnion = ({  }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const unionId = useParams().id;
    const unionData = useSelector(getClubUnion);
    const avatarList = useSelector(getAccountAvatars);
    // const clubBalance = useSelector(getClubChipBalance);
    const globalBalance = useSelector(getGlobalAccountBalance);
    const currentUnionAvatar = avatarList[unionId] ? (avatarList[unionId].imageUrl ? avatarList[unionId] : {}) : {};
    const [unionAvatar, setUnionAvatar] = useState({});
    const [changedOnce, setChangedOnce] = useState(false);
    const [nameChangePrice, setNameChangePrice] = useState(500);
    const [newName, setNewName] = useState("");

    const changeClubImage = (e) => {
        var reader = new FileReader();
        let fileName = e.target.value.split("\\");
        fileName = fileName[fileName.length - 1].split(".")[0];
        if (e.target.files[0]) {
            reader.readAsDataURL(e.target.files[0]);
        }
        reader.onload = function () {
            setTimeout(() => {
                setUnionAvatar({name: fileName, data: reader.result});
            }, 500)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };

    const saveChanges = () => {
        setChangedOnce(!changedOnce);
        dispatch(changeUnionDetails({
            unionId,
            unionName: newName ? newName : unionData.username,
            clubAvatar: unionAvatar.data ? unionAvatar : null
        }))
    };

    return (
        <div className="unionEditing">
            <Header title={'unionEditing'} to={`/union/${unionId}`}/>
            <button className="shareBtn"></button>
            <div className="unionEditingContent">
                <div className={"currentUnionAvatar"}>
                    <input id={"uploadAvatar"} type="file" accept="image/*" onChange={changeClubImage} />
                    {(unionAvatar.data || currentUnionAvatar.imageUrl) ? (<div className={'uploadAvatarPreview'} style={{backgroundImage: 'url(' + (unionAvatar.data || currentUnionAvatar.imageUrl) + ')'}}></div>) : ''}
                    <span className="changeAvatar">{t('unionEditingContent.change')}</span>
                </div>
                <div class="unionName form-group">
                    <label class="label form-label">{t('unionEditingContent.label')}</label>
                    <input name="unionname" type="text" class="form-control" onChange={(e) => setNewName(e)} defaultValue={unionData.username} />
                    {
                        changedOnce ? 
                        <div className="buyOption">
                            {t('unionEditingContent.price')}
                            <span className="sapphireIcon">{nameChangePrice}</span>
                        </div> :
                        <span className="notice">{t('unionEditingContent.notice')}</span>
                    }
                </div>
            </div>
            {
                (changedOnce && (globalBalance.diamonds < nameChangePrice)) &&
                <div className="purchaseReference">
                    {t('unionEditingContent.notEnough.0')}
                    <Link to="/shop/sapphires">{t('unionEditingContent.notEnough.1')}</Link>
                    {t('unionEditingContent.notEnough.2')}
                </div>
            }
            <div className="dialogConfirmBox">
                <button className="primary" onClick={saveChanges} >{t('unionEditingContent.save')}</button>
            </div>
        </div>
    );
};

export default EditUnion;
